/**
 * ERP Financial API client for fetching eligible child groups of a parent group.
 */

import { baseErpRequest } from './erpRequest';
import type { ErpSegmentGroup } from './segmentGroups';
import type { ErpApiError } from './types';

export type EligibleChildGroupsResponse = {
  message: string;
  statusCode: number;
  data: ErpSegmentGroup[];
  errors?: ErpApiError[] | null;
};

export type GetEligibleChildGroupsParams = {
  segmentId: number;
  groupId: number;
};

export const getEligibleChildGroups = async (
  { segmentId, groupId }: GetEligibleChildGroupsParams,
  clientOptions: RequestInit = {},
  hostUrl?: string
): Promise<EligibleChildGroupsResponse> => {
  return (await baseErpRequest(
    `/segments/${encodeURIComponent(segmentId)}/groups/${encodeURIComponent(groupId)}/eligible-child-groups`,
    clientOptions,
    hostUrl
  )
    .get()
    .json()) as EligibleChildGroupsResponse;
};
